import { Action } from '@ngrx/store';
import { Locale } from '../models/locale.model';

export enum ActionTypes {
  Update = '[Locales] Update',
  Receive = '[Locales] Receive',
}

export class Update implements Action {
  readonly type = ActionTypes.Update;
}

export class Receive implements Action {
  readonly type = ActionTypes.Receive;

  constructor(public payload: { locales: Locale[]; errorMessage: string }) {}
}

export type ActionList = Update | Receive;
